import { getPath } from "@lib/helper"
import { useRouteShellContext } from "@components/routeShellContext"
import NavMenu from "./NavMenu"
import Title from "./Title"
import "./styles.css"

export function SideMenu() {
  const { locale, pathname } = useRouteShellContext()
  const currentUrl = new URL(pathname, "https://playbrain.com")

  return (
    <aside className="side-menu">
      <Title />
      <nav
        className="nav-main"
        data-id="site-nav"
      >
        <NavMenu />
        <div className="language-container">
          <div className={`language ${locale === "en" ? "selected-lang" : ""}`}>
            <p>
              <a
                href={getPath("en", currentUrl)}
                aria-label="ENG"
              >
                ENG
              </a>
            </p>
          </div>
          <div className={`language ${locale === "ja" ? "selected-lang" : ""}`}>
            <p>
              <a
                href={getPath("ja", currentUrl)}
                aria-label="日本語"
              >
                日本語
              </a>
            </p>
          </div>
        </div>
      </nav>
    </aside>
  )
}

export default SideMenu
